// extracted by mini-css-extract-plugin
export default {"sliderDotsWrap":"sliderDotsWrap___kAODb","v2":"v2___c8kKl","sliderDotsList":"sliderDotsList___yXXur","sliderDot":"sliderDot___g3Shj"};